import { ResponseWrapper, ApiError } from './http';
import { BaseService } from './base.service';

export class OwnersService extends BaseService {
  static get resourceEndpoint() {
    return 'owners';
  }

  static async cancel(id) {
    try {
      const response = await this.request().patch(
        `${this.resourceEndpoint}/cancel/${id || ''}`
      );
      return new ResponseWrapper(response);
    } catch (error) {      throw new ApiError(error);
    }
  }

  static async freePeriodExtension(id) {
    try {
      const response = await this.request().patch(
        `${this.resourceEndpoint}/${id || ''}/extend_free_period`
      );
      return new ResponseWrapper(response);
    } catch (error) {      throw new ApiError(error);
    }
  }
}
